/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Hanly API v2
 * OpenAPI spec version: 0.0.1
 */
/**
 * 数量別単価ティア
 */
export interface CatalogQuantityPrice {
  min_quantity: number;
  max_quantity: number | null;
  price: string;
}

/**
 * カタログ商品の商品バリエーション。表示設定で非表示の項目と、料金を出さない組織の単価は null
 */
export interface EdiCatalogItemProductVariation {
  id: number;
  code: string | null;
  name: string;
  spec: string | null;
  manufacturer: string | null;
  model_number: string | null;
  unit_price: string | null;
  base_unit_price: string | null;
  quantity_prices: CatalogQuantityPrice[] | null;
  snp: string;
  packaging_type_name: string | null;
  unit_name: string | null;
  tax_class: string;
  thumbnail_url: string | null;
}

export interface EdiCatalogItem {
  id: number;
  product_variation: EdiCatalogItemProductVariation;
  description: string | null;
  sort_order: number;
}

/**
 * 明細行項目表示カラム定義
 */
export interface ItemDisplayColumn {
  key: string;
  label: string;
  visible: boolean;
  required: boolean;
  sort_order: number;
}

/**
 * カタログ商品一覧のページ。明細行の項目表示設定を一緒に返す
 */
export interface EdiCatalogItemPage {
  count: number;
  next: string | null;
  previous: string | null;
  results: EdiCatalogItem[];
  item_display_columns: ItemDisplayColumn[];
}

export interface StandardizedErrorDetail {
  attr: string | null;
  code: string;
  detail: string;
}

/**
 * 検証エラー(400)のボディ。utils.api_v1.serializers.StandardizedErrorSerializer と同じ形
 */
export interface StandardizedError {
  type: string;
  errors: StandardizedErrorDetail[];
}

/**
 * 検証エラー以外のエラーボディ
 */
export interface DetailError {
  detail: string;
}

/**
 * カタログ商品の添付ファイル。ダウンロードURLは都度ダウンロードURL取得APIで発行する
 */
export interface EdiCatalogItemAttachment {
  id: number;
  name: string;
  file_type: string;
  created_at: string;
}

export interface PresignedUrlResponse {
  presigned_url: string;
  object_key: string;
}

export interface EdiInvitationAcceptRequest {
  invitation_key: string;
  username: string;
  password: string;
}

export type EdiInvitationAcceptResponseResult =
  (typeof EdiInvitationAcceptResponseResult)[keyof typeof EdiInvitationAcceptResponseResult];

export const EdiInvitationAcceptResponseResult = {
  activated: 'activated',
} as const;

export interface EdiInvitationAcceptResponse {
  result: EdiInvitationAcceptResponseResult;
}

export interface EdiInvitationValidateRequest {
  invitation_key: string;
}

export type EdiInvitationValidateResponseResult =
  (typeof EdiInvitationValidateResponseResult)[keyof typeof EdiInvitationValidateResponseResult];

export const EdiInvitationValidateResponseResult = {
  activated: 'activated',
  need_sign_up: 'need_sign_up',
} as const;

export interface EdiInvitationValidateResponse {
  result: EdiInvitationValidateResponseResult;
  organization_name: string;
  email: string | null;
}

/**
 * アニマルEDIに表示する掲載中のお知らせ
 */
export interface EdiPublishedNotice {
  id: number;
  title: string;
  start_date: string;
}

export interface EdiPasswordResetRequest {
  email: string;
}

export interface EdiPasswordResetCompleteRequest {
  key: string;
  new_password: string;
}

/**
 * EDIアカウントに紐付く取引先
 */
export interface EdiPartner {
  id: number;
  partner_name: string;
  supplier_name: string;
  show_prices: boolean;
}

export interface EdiProfile {
  id: number;
  email: string;
  username: string;
  partners: EdiPartner[];
}

/**
 * EDI発注ステータス
 */
export type EdiPurchaseOrderStatusEnum =
  (typeof EdiPurchaseOrderStatusEnum)[keyof typeof EdiPurchaseOrderStatusEnum];

export const EdiPurchaseOrderStatusEnum = {
  CONFIRMED: 'CONFIRMED',
  PENDING: 'PENDING',
} as const;

export type EdiPurchaseOrderListTaxBreakdown = { [key: string]: unknown } | null;

/**
 * EDI発注一覧の行。料金を出さない組織では金額の項目は null
 */
export interface EdiPurchaseOrderList {
  id: number;
  desired_delivery_date: string | null;
  subtotal: string | null;
  tax_breakdown: EdiPurchaseOrderListTaxBreakdown;
  total_amount: string | null;
  status: EdiPurchaseOrderStatusEnum;
  item_count: number;
  orderer_name: string;
  created_at: string;
  updated_at: string;
}

export interface PaginatedEdiPurchaseOrderList {
  count: number;
  next: string | null;
  previous: string | null;
  results: EdiPurchaseOrderList[];
}

export interface EdiPurchaseOrderItemCreateRequest {
  product_variation_id: number;
  quantity: string;
  desired_delivery_date?: string | null;
}

/**
 * 明細を省略・空にすると取引先のカタログ商品から数量 0 の明細を作る
 */
export interface EdiPurchaseOrderCreateRequest {
  desired_delivery_date?: string | null;
  notes?: string;
  items?: EdiPurchaseOrderItemCreateRequest[];
}

export type EdiPurchaseOrderDetailResponseTaxBreakdown = { [key: string]: unknown } | null;

export type EdiPurchaseOrderItemTaxClass =
  (typeof EdiPurchaseOrderItemTaxClass)[keyof typeof EdiPurchaseOrderItemTaxClass];

export const EdiPurchaseOrderItemTaxClass = {
  TAX_RATE_10: 'TAX_RATE_10',
  TAX_RATE_8_REDUCED: 'TAX_RATE_8_REDUCED',
  EXEMPTION: 'EXEMPTION',
  FREE: 'FREE',
} as const;

/**
 * 数量別単価ティア
 */
export interface EdiQuantityPrice {
  min_quantity: number;
  max_quantity: number | null;
  price: string;
}

/**
 * EDI発注明細。表示設定で非表示の項目と、料金を出さない組織の単価・金額は null
 */
export interface EdiPurchaseOrderItem {
  id: number;
  product_variation: number | null;
  variation_snp: string | null;
  packaging_type_name: string | null;
  product_code: string | null;
  model_number: string | null;
  name: string;
  spec: string | null;
  manufacturer: string | null;
  unit_price: string | null;
  snp: string;
  quantity: string;
  unit: number | null;
  unit_name: string | null;
  amount: string | null;
  tax_class: EdiPurchaseOrderItemTaxClass;
  desired_delivery_date: string | null;
  last_purchased_at: string | null;
  sort_order: number | null;
  created_at: string;
  updated_at: string;
  base_unit_price: string | null;
  quantity_prices: EdiQuantityPrice[] | null;
  thumbnail_url: string | null;
}

/**
 * EDI発注詳細。料金を出さない組織では金額の項目は null
 */
export interface EdiPurchaseOrderDetailResponse {
  id: number;
  partner: number;
  desired_delivery_date: string | null;
  subtotal: string | null;
  tax_breakdown: EdiPurchaseOrderDetailResponseTaxBreakdown;
  total_amount: string | null;
  status: EdiPurchaseOrderStatusEnum;
  notes: string;
  items: EdiPurchaseOrderItem[];
  created_at: string;
  updated_at: string;
  item_display_columns: ItemDisplayColumn[];
}

export interface EdiPurchaseOrderItemUpdateRequest {
  id: number;
  quantity: string;
  desired_delivery_date?: string | null;
}

/**
 * 省略した項目は変更しない。明細は送った明細だけ更新する
 */
export interface EdiPurchaseOrderUpdateRequest {
  desired_delivery_date?: string | null;
  notes?: string;
  items?: EdiPurchaseOrderItemUpdateRequest[];
}

export interface EdiTokenObtainRequest {
  email: string;
  password: string;
}

export interface EdiTokenObtainResponse {
  access: string;
  refresh: string;
}

export type EdiTokenObtainUnauthorizedCode =
  (typeof EdiTokenObtainUnauthorizedCode)[keyof typeof EdiTokenObtainUnauthorizedCode];

export const EdiTokenObtainUnauthorizedCode = {
  MFA_REQUIRED: 'MFA_REQUIRED',
} as const;

/**
 * ログインの 401
 *
 * メールアドレスかパスワードが違うときは detail だけ。MFA が有効なユーザーはパスワードが合っていても
 * トークンの代わりに code(MFA_REQUIRED)と mfa_token を返す。v1 と同じボディ。
 */
export interface EdiTokenObtainUnauthorized {
  detail: string;
  code?: EdiTokenObtainUnauthorizedCode;
  mfa_token?: string;
}

export interface EdiTokenMfaRequest {
  mfa_token: string;
  /** @maxLength 32 */
  mfa_code: string;
}

/**
 * アニマルID から戻り先に渡された認可コードと、ログインを始めるときに画面が作った値
 */
export interface EdiTokenOidcRequest {
  code: string;
  code_verifier: string;
  nonce: string;
}

export interface EdiTokenOidcResponse {
  access: string;
  refresh: string;
  id_token: string;
}

export interface EdiTokenRefreshRequest {
  refresh: string;
}

export interface EdiTokenRefreshResponse {
  access: string;
}

export type EdiCatalogItemListParams = {
  page?: number;
  page_size?: number;
  code?: string | null;
  name?: string | null;
  spec?: string | null;
  model_number?: string | null;
  unit_price_min?: string | null;
  unit_price_max?: string | null;
  ordering?: EdiCatalogItemListOrdering;
};

export type EdiCatalogItemListOrdering =
  | (typeof EdiCatalogItemListOrdering)[keyof typeof EdiCatalogItemListOrdering]
  | null;

export const EdiCatalogItemListOrdering = {
  code: 'code',
  name: 'name',
  spec: 'spec',
  model_number: 'model_number',
  unit_price: 'unit_price',
  '-code': '-code',
  '-name': '-name',
  '-spec': '-spec',
  '-model_number': '-model_number',
  '-unit_price': '-unit_price',
} as const;

export type EdiPurchaseOrderListParams = {
  page?: number;
  page_size?: number;
  id?: string | null;
  created_at_from?: string | null;
  created_at_to?: string | null;
  desired_delivery_date_from?: string | null;
  desired_delivery_date_to?: string | null;
  total_amount_min?: string | null;
  total_amount_max?: string | null;
  orderer_name?: string | null;
  status?: EdiPurchaseOrderStatusEnum | null;
  ordering?: EdiPurchaseOrderListOrdering;
};

export type EdiPurchaseOrderListOrdering =
  | (typeof EdiPurchaseOrderListOrdering)[keyof typeof EdiPurchaseOrderListOrdering]
  | null;

export const EdiPurchaseOrderListOrdering = {
  id: 'id',
  created_at: 'created_at',
  desired_delivery_date: 'desired_delivery_date',
  total_amount: 'total_amount',
  orderer_name: 'orderer_name',
  status: 'status',
  '-id': '-id',
  '-created_at': '-created_at',
  '-desired_delivery_date': '-desired_delivery_date',
  '-total_amount': '-total_amount',
  '-orderer_name': '-orderer_name',
  '-status': '-status',
} as const;
